"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Subtitle = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var Title = exports.Title = function Title(_ref) {
  var name = _ref.name,
    _ref$isPlural = _ref.isPlural,
    isPlural = _ref$isPlural === void 0 ? false : _ref$isPlural;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-2xl font-bold text-dark",
    style: {
      maxWidth: 400
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "dnd.drop.category.title",
    count: isPlural ? 2 : 1
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-primary"
  }, {
    name: name
  })));
};
var Subtitle = exports.Subtitle = function Subtitle(_ref2) {
  var name = _ref2.name,
    onClick = _ref2.onClick,
    _ref2$isPlural = _ref2.isPlural,
    isPlural = _ref2$isPlural === void 0 ? false : _ref2$isPlural;
  return /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "dnd.drop.category.subtitle",
    count: isPlural ? 2 : 1
  }, /*#__PURE__*/_react["default"].createElement("span", null, {
    name: name
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('text-primary', {
      'cursor-pointer hover:underline': !!onClick
    }),
    onClick: onClick
  }));
};
//# sourceMappingURL=Category.js.map